import script from "./addressBookPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./addressBookPopup.vue?vue&type=script&lang=ts&setup=true"

import "./addressBookPopup.vue?vue&type=style&index=0&id=3d8d5c9e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d8d5c9e"]])

export default __exports__